export default "__VITE_ASSET__D0e2ZjtN__"